import React, { useState } from 'react';
import { animateScroll } from 'react-scroll';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { FiMenu, FiX, FiChevronDown } from 'react-icons/fi';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [showServicesDropdown, setShowServicesDropdown] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const scrollTo = (section) => {
        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(() => {
                scrollToSection(section);
            }, 300); // allow time for page to render
        } else {
            scrollToSection(section);
        }
    };

    const scrollToSection = (section) => {
        animateScroll.scrollTo(document.getElementById(section)?.offsetTop - 20 || 0, {
            duration: 500,
        });
    };

    return (
        <nav className="bg-black text-white sticky top-0 z-50 shadow-md">
            <div className="px-6 md:px-16 py-4 flex justify-between items-center">
                {/* Logo */}
                <RouterLink to="/" className="text-red-500 font-mono text-xl font-semibold flex items-center">
                    <img src="/logo.png" alt="SiberLab Logo" className="h-12 w-auto cursor-pointer" />
                </RouterLink>

                {/* Desktop Navigation */}
                <ul className="hidden md:flex gap-6 font-medium items-center">
                    <li>
                        <span onClick={() => { setIsOpen(false); scrollTo('home'); }} className="cursor-pointer hover:text-red-500">
                            Home
                        </span>
                    </li>

                    <li
                        className="relative"
                        onMouseEnter={() => setShowServicesDropdown(true)}
                        onMouseLeave={() => setShowServicesDropdown(false)}
                    >
                        <span className="cursor-pointer hover:text-red-500 flex items-center gap-1">
                            Services <FiChevronDown />
                        </span>
                        {showServicesDropdown && (
                            <ul className="absolute bg-black border border-gray-700 w-64 py-2 rounded shadow-lg z-10">
                                <li>
                                    <RouterLink to="/services/cybersecurity-training"
                                        onClick={() => { setIsOpen(false); scrollTo('hero'); }}
                                        className="block px-4 py-2 hover:bg-red-500 hover:text-white">
                                        Cybersecurity Training
                                    </RouterLink>
                                </li>
                                <li>
                                    <RouterLink to="/services/red-team"
                                        onClick={() => { setIsOpen(false); scrollTo('hero'); }}
                                        className="block px-4 py-2 hover:bg-red-500 hover:text-white">
                                        Red Team Operations
                                    </RouterLink>
                                </li>
                                <li>
                                    <RouterLink to="https://akademi.siberlab.id/"
                                        onClick={() => { setIsOpen(false); scrollTo('hero'); }}
                                        className="block px-4 py-2 hover:bg-red-500 hover:text-white">
                                        Akademi Siber
                                    </RouterLink>
                                </li>
                            </ul>
                        )}
                    </li>

                    <li>
                        <span onClick={() => scrollTo('testimonials')} className="cursor-pointer hover:text-red-500">
                            Testimonials
                        </span>
                    </li>
                    <li>
                        <span onClick={() => scrollTo('contact')} className="cursor-pointer hover:text-red-500">
                            Contact
                        </span>
                    </li>
                </ul>

                {/* Mobile Toggle Button */}
                <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-2xl">
                    {isOpen ? <FiX /> : <FiMenu />}
                </button>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <ul className="md:hidden bg-black px-6 py-4 flex flex-col gap-4 border-t border-gray-700">
                    <li>
                        <RouterLink to="/" onClick={() => setIsOpen(false)} className="hover:text-red-500">
                            Home
                        </RouterLink>
                    </li>

                    <li>
                        <span className="text-gray-300">Services</span>
                        <ul className="ml-4 mt-2 border-l border-gray-600 pl-4 text-sm">
                            <li>
                                <RouterLink
                                    to="/services/cybersecurity-training"
                                    onClick={() => { setIsOpen(false); scrollTo('hero'); }}
                                    className="block py-1 hover:text-red-500"
                                >
                                    Cybersecurity Training
                                </RouterLink>
                            </li>
                            <li>
                                <RouterLink
                                    to="/services/red-team"
                                    onClick={() => { setIsOpen(false); scrollTo('hero'); }}
                                    className="block py-1 hover:text-red-500"
                                >
                                    Red Team Operations
                                </RouterLink>
                            </li>
                            <li>
                                <RouterLink
                                    to="https://akademi.siberlab.id/"
                                    onClick={() => { setIsOpen(false); scrollTo('hero'); }}
                                    className="block py-1 hover:text-red-500"
                                >
                                    Akademi Siber
                                </RouterLink>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <span onClick={() => { setIsOpen(false); scrollTo('testimonials'); }} className="cursor-pointer hover:text-red-500">
                            Testimonials
                        </span>
                    </li>
                    <li>
                        <span onClick={() => { setIsOpen(false); scrollTo('contact'); }} className="cursor-pointer hover:text-red-500">
                            Contact
                        </span>
                    </li>
                </ul>
            )}
        </nav>
    );
};

export default Navbar;
